import { type LucideProps } from 'lucide-react'

/**
 * Recenter Icon (Custom Design)
 *
 * Crosshair/target icon for recentering the graph view.
 * Simple center crosshair with circle used in ReactFlow controls.
 */
export function Recenter({ size = 24, className = '', ...props }: LucideProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="square"
      {...props}
    >
      {/* Circle */}
      <circle cx="16" cy="16" r="10" fill="none" />
      {/* Vertical line - top */}
      <line x1="16" y1="0" x2="16" y2="11" />
      {/* Vertical line - bottom */}
      <line x1="16" y1="21" x2="16" y2="32" />
      {/* Horizontal line - left */}
      <line x1="0" y1="16" x2="11" y2="16" />
      {/* Horizontal line - right */}
      <line x1="21" y1="16" x2="32" y2="16" />
    </svg>
  )
}
